import * as companyService from "../../../../services/company";
import * as originPackageService from "../../../../services/originPackage";
import * as settings from "../../../../services/settings";

import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Spin, Tabs, Typography, notification } from "antd";
import {
  convertToDayjs,
  DATETIME_PICKER_FORMAT,
  DATETIME_PICKER_SHOW_TIME,
  formatDate,
} from "../../../../utils/date";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  validateCreateOriginPackage,
  validateSubmitCreateOriginPackage,
} from "../../../../Components/validations/validateCreateOriginPackage";

import BtnHistory from "../../../../Components/model/button/history";
import ContentType from "../../../../../configs/contentType";
import { CreateOriginPackageDetail } from "../../../../Components/package/packageDetail";
import { CreateOriginPackageServices } from "../../../../Components/package/packageServices";
import { Space } from "antd";
import permissions from "../../../../../configs/permission";
import { useAccessToken } from "../../../../contexts/AccessTokenContext";
import { usePermission } from "../../../../hooks/usePermission";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveImageUrl } from "../../../../utils/imageUrl";

const { Title, Text } = Typography;

const pendingWareHouseCreateByToken = new Map();
const pendingCustomerListCreateByToken = new Map();
const pendingOriginPackageByIdByKey = new Map();

const CREATE = "CREATE";
const EDIT = "EDIT";

export const OriginPackageCreatePage = () => {
  const { hasPermission } = usePermission();
  const { accessToken } = useAccessToken();
  const hasInitialized = useRef(false);
  const saleRef = useRef([]);
  const customerRef = useRef([]);
  const [formOriginPackage] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [isCreate, setIsCreate] = useState(false);
  const [isCheckCreateSuccess, setIsCreateSuccess] = useState(false);
  const { t, i18n } = useTranslation("packages");
  const [dataOriginPackage, setDataOriginPackage] = useState([]);
  const [fileList, setFileList] = useState(Array(12).fill(null));
  const [listWareHouseOrigin, setListWareHouseOrigin] = useState([]);
  const [listWareHouseDestination, setListWareHouseDestination] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  // customer
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [listCustomer, setListCustomer] = useState([]);
  const [searchCustomer, setSearchCustomer] = useState("");
  // company
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [listCompany, setListCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  // sale
  const [loadingSale, setLoadingSale] = useState(false);
  const [listSale, setListSale] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null);

  const [allSales, setAllSales] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);

  const [params] = useSearchParams();

  const id = params.get("id");
  const mode = params.get("mode");

  const location = useLocation();
  const [data, setData] = useState();
  const [originPackageData, setOriginPackageData] = useState();

  const isReadOnlyByPermission = isEdit && !hasPermission(permissions.OriginPackage.CHANGE);
  const navigation = useNavigate();
  // Validate field is required
  const [validateFieldRequired, setValidateFieldRequired] = useState({
    fieldShipping: false,
    fieldReference: false,
    fieldTracking: false,
    fieldRoute: false,
    fieldOrigin: false,
    fieldDestination: false,
    fieldCustomer: false,
    fieldType: true,
    fieldPackageStatus: true,
    fieldTotalCount: true,
    fieldLength: false,
    fieldHeight: false,
    fieldWeight: false,
    fieldWeightType: true,
    fieldAmount: true,
  });

  const [api, contextHolder] = notification.useNotification();
  const canViewOriginPackage = hasPermission(permissions.OriginPackage.VIEW);
  const canViewOriginPackageService = hasPermission(permissions.OriginPackageService.VIEW);
  const canViewAnyOriginPackageSection = canViewOriginPackage || canViewOriginPackageService;
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const setDetailData = (data, allSales, allCustomers) => {
    formOriginPackage.setFieldValue("shipping", data.shipping);
    formOriginPackage.setFieldValue("reference", data.reference);
    formOriginPackage.setFieldValue("box", data.box);
    formOriginPackage.setFieldValue("tracking", data.tracking);
    formOriginPackage.setFieldValue("custom_no", data.custom_no);
    formOriginPackage.setFieldValue("route", data.route);

    formOriginPackage.setFieldValue("origin_package_time", convertToDayjs(data.origin_package_time));
    formOriginPackage.setFieldValue("origin_transportation_time", convertToDayjs(data.origin_transportation_time));
    formOriginPackage.setFieldValue("destination_package_time", convertToDayjs(data.destination_package_time));
    formOriginPackage.setFieldValue("destination_delivery_time", convertToDayjs(data.destination_delivery_time));

    let origin = data.app_warehouse_app_originpackage_origin_idToapp_warehouse;
    if (origin) {
      formOriginPackage.setFieldValue(
        "origin",
        data.app_warehouse_app_originpackage_origin_idToapp_warehouse.warehouse_code
      );
    }

    let destination = data.app_warehouse_app_originpackage_destination_idToapp_warehouse;
    if (destination) {
      formOriginPackage.setFieldValue(
        "destination",
        data.app_warehouse_app_originpackage_destination_idToapp_warehouse.warehouse_code
      );
    }

    formOriginPackage.setFieldValue("note", data.note);

    if (allSales && data.app_company && data.app_sale) {
      const filteredSales = allSales.filter((s) => s.value.startsWith(`${data.app_company.id},`));
      setListSale(filteredSales);
    }

    if (allCustomers && data.app_company && data.app_sale && data.app_customer) {
      const filteredCustomers = allCustomers.filter((c) =>
        c.value.startsWith(`${data.app_company.id},${data.app_sale.id},`)
      );
      setListCustomer(filteredCustomers);
    }
    if (data.app_company) {
      formOriginPackage.setFieldValue("company", `${data.app_company.id}`);
    }
    if (data.app_sale) {
      formOriginPackage.setFieldValue("sale", `${data.app_company.company_code}-${data.app_sale.sale_code}`);
    }
    if (data.app_customer) {
      formOriginPackage.setFieldValue(
        "customer",
        `${data.app_company.company_code}-${data.app_sale.sale_code}${data.app_customer.customer_code}`
      );
    }

    // Detail
    formOriginPackage.setFieldValue("description_detail", data.package_description);
    formOriginPackage.setFieldValue("type", data.package_type);
    formOriginPackage.setFieldValue("package_status", data.package_status);
    formOriginPackage.setFieldValue("total_count", data.total_count);
    formOriginPackage.setFieldValue("length", data.length);
    formOriginPackage.setFieldValue("width", data.width);
    formOriginPackage.setFieldValue("height", data.height);
    formOriginPackage.setFieldValue("weight", data.weight);
    formOriginPackage.setFieldValue("weight_type", data.weight_type);
    formOriginPackage.setFieldValue("amount", data.amount);
    if (data && data.app_originpackageimage !== undefined) {
      if (data.app_originpackageimage.length > 0) {
        const imagesByPosition = Array(12).fill(null); // ตำแหน่ง 0-11 (Package 1-12)
        const hasUploadsPath = (path) => path && path.startsWith("uploads/");
        data.app_originpackageimage.map((value, index) => {
          const imageUrl = resolveImageUrl(value.image);
          const fileItem = {
            uid: value.image.substring(0, 80) + value.id,
            name: `image_${value.id}.png`,
            status: "done",
            url: imageUrl,
            id: value.id,
          };

          if (hasUploadsPath(value.image)) {
            // รูปแบบใหม่: ดึง position จาก path เช่น uploads/7-origin-packages-...
            const match = value.image.match(/uploads\/(\d+)-origin-packages/);
            const position = match ? parseInt(match[1], 10) : null;
            if (position && position >= 1 && position <= 12) {
              imagesByPosition[position - 1] = { ...fileItem, uid: value.image.substring(42, 78) };
            }
          } else {
            // รูปแบบเดิม: ไม่มี uploads ใน path ใช้ index เป็นตำแหน่ง (ไม่เกิน 12)
            if (index >= 0 && index < 12) {
              imagesByPosition[index] = fileItem;
            }
          }
        });
        setFileList(imagesByPosition);
      }
    }
  };

  const validateDataOriginPackageRequired = async (name, value) => {
    await validateCreateOriginPackage(validateFieldRequired, setValidateFieldRequired, name, value);
  };

  const buildOriginPackageFormData = (values, { fallbackRelationIds, fallbackWarehouseIds } = {}) => {
    const parseText = (value) => String(value ?? "");
    const parseNumber = (value) => Number(value);

    const parseCustomerTriplet = (customerValue) => {
      const [companyId, saleId, customerId] = String(customerValue ?? "").split(",");
      if (companyId && saleId && customerId) {
        return {
          company_id: companyId,
          sale_id: saleId,
          customer_id: customerId,
        };
      }

      if (fallbackRelationIds) {
        return {
          company_id: String(fallbackRelationIds.company_id ?? ""),
          sale_id: String(fallbackRelationIds.sale_id ?? ""),
          customer_id: String(fallbackRelationIds.customer_id ?? ""),
        };
      }

      return {
        company_id: "",
        sale_id: "",
        customer_id: "",
      };
    };

    const relationIds = parseCustomerTriplet(values.customer);
    const originValue =
      values.origin ?? fallbackWarehouseIds?.origin_id ?? null;
    const destinationValue =
      values.destination ?? fallbackWarehouseIds?.destination_id ?? null;

    const formData = new FormData();
    formData.append("shipping", parseText(values.shipping));
    formData.append("reference", parseText(values.reference));
    formData.append("box", parseText(values.box));
    formData.append("tracking", parseText(values.tracking));
    formData.append("custom_no", parseText(values.custom_no));
    formData.append("route", parseText(values.route));
    formData.append("origin_id", String(parseNumber(originValue)));
    formData.append("destination_id", String(parseNumber(destinationValue)));
    formData.append("origin_package_time", formatDate(values.origin_package_time, "YYYY-MM-DD HH:mm:00"));
    formData.append(
      "origin_transportation_time",
      formatDate(values.origin_transportation_time, "YYYY-MM-DD HH:mm:00")
    );
    formData.append("destination_package_time", formatDate(values.destination_package_time, "YYYY-MM-DD HH:mm:00"));
    formData.append("destination_delivery_time", formatDate(values.destination_delivery_time, "YYYY-MM-DD HH:mm:00"));
    formData.append("note", values.note || "");
    formData.append("company_id", relationIds.company_id);
    formData.append("sale_id", relationIds.sale_id);
    formData.append("customer_id", relationIds.customer_id);
    formData.append("package_description", parseText(values.description_detail));
    formData.append("package_type", parseText(values.type));
    formData.append("package_status", parseText(values.package_status));
    formData.append("total_count", String(parseNumber(values.total_count)));
    formData.append("length", String(parseNumber(values.length)));
    formData.append("width", String(parseNumber(values.width)));
    formData.append("height", String(parseNumber(values.height)));
    formData.append("weight", String(parseNumber(values.weight)));
    formData.append("weight_type", parseText(values.weight_type));
    formData.append("amount", String(parseNumber(values.amount)));

    const old_images = [];
    const file_positions = [];
    if (fileList.length > 0) {
      fileList.map((file, index) => {
        if (file !== null && file !== undefined) {
          if (file?.id !== undefined && file?.id !== null) {
            old_images.push(file.id);
          } else if (file && file.originFileObj) {
            formData.append("file", file.originFileObj);
            file_positions.push(index + 1);
          }
        }
      });
      formData.append("file_positions", JSON.stringify(file_positions));
      formData.append("old_images", JSON.stringify(old_images));
    }

    return { formData };
  };

  const getFormData = () => {
    const values = formOriginPackage.getFieldsValue();
    return buildOriginPackageFormData(values).formData;
  };

  const onSaveAddAnother = async () => {
    if (loading) return;
    const values = await formOriginPackage.getFieldsValue();
    const { isValid } = validateSubmitCreateOriginPackage(values);

    if (isValid) {
      try {
        const formData = getFormData();
        setLoading(true);
        await originPackageService.createOriginPackage(accessToken, formData);
        openNotificationWithIcon(settings.NotificationType.SUCCESS, "Success.", "Create origin package success");
        formOriginPackage.resetFields(["note", "total_count", "weight_type", "amount"]);
        setDataOriginPackage([]);
        setIsCreateSuccess(false);
        setLoading(false);
      } catch (err) {
        console.error("[OriginPackageCreatePage] onSaveAddAnother: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
    } else {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        "ERROR.",
        <>{`Please check data is request create origin package`}</>
      );
    }
  };

  const performOriginPackageSave = async ({ navigateToListOnCreate }) => {
    const values = await formOriginPackage.getFieldsValue();
    const {
      shipping,
      reference,
      box,
      tracking,
      custom_no,
      route,
      origin,
      destination,
      origin_package_time,
      origin_transportation_time,
      destination_package_time,
      destination_delivery_time,
      note,
      customer,
      description_detail,
      type,
      package_status,
      total_count,
      length,
      width,
      height,
      weight,
      weight_type,
      amount,
    } = values || {};

    const { isValid } = validateSubmitCreateOriginPackage(values);

    if (!isValid) {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        <>{"ERROR."}</>,
        <>{`Please check data is request create/update origin package`}</>
      );
      return false;
    }

    // const persistedPackage =
    //   originPackageData?.id != null
    //     ? originPackageData
    //     : originPackageData?.originPackageData?.id != null
    //       ? originPackageData.originPackageData
    //       : dataOriginPackage?.id != null
    //         ? dataOriginPackage
    //         : null;

    const persistedPackage = originPackageData ?? dataOriginPackage;

    const fallbackRelationIds = persistedPackage
      ? {
          company_id: persistedPackage?.app_company?.id,
          sale_id: persistedPackage?.app_sale?.id,
          customer_id: persistedPackage?.app_customer?.id,
        }
      : undefined;

    const fallbackWarehouseIds = persistedPackage
      ? {
          origin_id: persistedPackage?.origin_id,
          destination_id: persistedPackage?.destination_id,
        }
      : undefined;

    const fromData = buildOriginPackageFormData(values, {
      fallbackRelationIds,
      fallbackWarehouseIds,
    }).formData;

    setLoading(true);
    try {
      if (!persistedPackage?.id) {
        const response = await originPackageService.createOriginPackage(accessToken, fromData);
        if (response == null) {
          setLoading(false);
          return false;
        }
        openNotificationWithIcon(
          settings.NotificationType.SUCCESS,
          <>{"Success."}</>,
          <>{"Create origin package success"}</>
        );
        setIsCreateSuccess(true);
        const savedPackage = await originPackageService.getOriginPackageById(accessToken, response.id);
        setIsCreate(true);
        setDataOriginPackage(savedPackage);
        if (navigateToListOnCreate) {
          navigation("/package/originpackage");
        } else {
          setActiveTabKey("2");
        }
        setLoading(false);
        return true;
      }

      const updateID = persistedPackage.id ?? id;
      fromData.append("id", updateID);
      const response = await originPackageService.updateOriginPackage(accessToken, fromData, updateID);
      if (response == null) {
        setLoading(false);
        return false;
      }
      setDetailData(response);
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        <>{"Success."}</>,
        <>{"Update origin package success"}</>
      );
      if (navigateToListOnCreate) {
        if (data?.type === "CREATE") {
          navigation("/package/originpackage");
        }
      } else {
        setActiveTabKey("2");
      }
      setLoading(false);
      return true;
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[OriginPackageCreatePage] performOriginPackageSave: ", err);
      setLoading(false);
      return false;
    }
  };

  const onSubmit = async () => {
    await performOriginPackageSave({ navigateToListOnCreate: true });
  };

  const onServiceTabClick = async () => {
    if (loading) return;
    const ok = await performOriginPackageSave({ navigateToListOnCreate: false });
    if (!ok) return;
  };

  const fetchWareHouseData = useCallback(
    async (param) => {
      const requestKey = accessToken;
      const existing = pendingWareHouseCreateByToken.get(requestKey);
      if (existing) {
        return existing;
      }

      const promise = (async () => {
        setLoading(true);
        let origin = [];
        let destination = [];
        try {
          const data = await originPackageService.getWareHouses(accessToken);
          data.map((value) => {
            if (value.is_origin === true) {
              origin.push({
                value: value.id,
                label: `${value.warehouse_code}`,
              });
            }
            if (value.is_destination === true) {
              destination.push({
                value: value.id,
                label: `${value.warehouse_code}`,
              });
            }
          });
          setListWareHouseDestination(destination);
          setListWareHouseOrigin(origin);
        } catch (err) {
          console.error("[OriginPackageCreatePage] fetchWareHouseData: ", err);
          const { message } = settings.getErrorMessage(err);
          openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
          setLoading(false);
        } finally {
          pendingWareHouseCreateByToken.delete(requestKey);
        }
        setLoading(false);
      })();

      pendingWareHouseCreateByToken.set(requestKey, promise);
      return promise;
    },
    [accessToken]
  );

  const fetchCustomerList = useCallback(async () => {
    const requestKey = accessToken;
    const existing = pendingCustomerListCreateByToken.get(requestKey);
    if (existing) {
      return existing;
    }

    const promise = (async () => {
      setLoading(true);
      let customer = [];
      let company = [];
      let sale = [];
      try {
        const data = await companyService.getCompanysList(accessToken);
        data.map((value) => {
          company.push({
            value: `${value.id}`,
            label: `${value.company_code}`,
          });
          if (value.app_sale.length > 0) {
            value.app_sale.map((saleValue) => {
              sale.push({
                value: `${value.id},${saleValue.id}`,
                label: `${value.company_code}-${saleValue.sale_code}`,
              });
              if (saleValue.app_customer.length > 0) {
                saleValue.app_customer.map((customerValue) => {
                  customer.push({
                    value: `${value.id},${saleValue.id},${customerValue.id}`,
                    label: `${value.company_code}-${saleValue.sale_code}${customerValue.customer_code}`,
                  });
                });
              }
            });
          }
        });
        setListCustomer(customer);
        setListCompany(company);
        setListSale(sale);

        setAllSales(sale);
        setAllCustomers(customer);
        saleRef.current = sale;
        customerRef.current = customer;

        setLoading(false);
        setLoadingCustomer(false);
        setLoadingCompany(false);
        setLoadingSale(false);
      } catch (err) {
        console.error("[OriginPackageCreatePage] fetchCustomerList: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      } finally {
        pendingCustomerListCreateByToken.delete(requestKey);
      }
    })();

    pendingCustomerListCreateByToken.set(requestKey, promise);
    return promise;
  }, [accessToken]);

  const fetchOriginPackageById = useCallback(
    async (id) => {
      const requestKey = `${accessToken}:${id}`;
      const existing = pendingOriginPackageByIdByKey.get(requestKey);
      if (existing) {
        return existing;
      }

      const promise = (async () => {
        setLoading(true);
        try {
          const data = await originPackageService.getOriginPackageById(accessToken, id);
          setOriginPackageData(data);
          setDataOriginPackage(data);
          setDetailData(data);
        } catch (err) {
          console.error("[OriginPackageCreatePage] fetchOriginPackageById: ", err);
          const { message } = settings.getErrorMessage(err);
          openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
          setLoading(false);
        } finally {
          pendingOriginPackageByIdByKey.delete(requestKey);
        }
      })();

      pendingOriginPackageByIdByKey.set(requestKey, promise);
      return promise;
    },
    [accessToken]
  );
  // Customer
  const handleSearchCustomer = async (value) => {
    if (!value) {
      setSearchCustomer("");
    } else if (value !== searchCustomer) {
      setSearchCustomer("");
    }
    setSearchCustomer(value);
    await filterCustomer(value);
  };
  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const filterCustomer = async (saleData) => {
    await listCustomer.filter((value) => value.label.includes(saleData));
  };

  // Company
  const filterOptionCompany = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  // Sale
  const filterOptionSale = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    const init = async () => {
      if (!accessToken || hasInitialized.current) return;
      hasInitialized.current = true;

      if (!canViewAnyOriginPackageSection) return;

      setLoading(true);
      setLoadingCustomer(true);

      await fetchWareHouseData();
      await fetchCustomerList();

      // state (same tab)
      if (location.state) {
        setIsCreate(true);
        setData(location.state);
      }

      // edit mode (new tab / refresh)
      if (mode === "edit" && id) {
        setIsEdit(true);
        await fetchOriginPackageById(id);
        setIsCreateSuccess(false);
      }

      setLoading(false);
      const lang = localStorage.getItem("lang") || "en";
      i18n.changeLanguage(lang);
    };

    init();
  }, [accessToken, canViewAnyOriginPackageSection, originPackageData, i18n.language]);

  const hasPersistedOriginPackage = dataOriginPackage?.id != null || data?.originPackageData?.id != null;

  const saveButtonDisabled = isCreate
    ? Object.entries(validateFieldRequired).some(([field, value]) => value === false) ||
      (isCheckCreateSuccess && !hasPersistedOriginPackage)
    : false;

  const serviceTabDisabled = saveButtonDisabled || loading;

  const handleTabsChange = (key) => {
    if (key === "2") {
      void onServiceTabClick();
      return;
    }
    setActiveTabKey(key);
  };

  const initialItems = [
    {
      label: t("Origin_Package_Create.Create_Detail.Title_Detail"),
      children: canViewOriginPackage && (
        <CreateOriginPackageDetail
          t={t}
          type={isCreate ? CREATE : EDIT}
          formOriginPackage={formOriginPackage}
          detailData={dataOriginPackage}
          validateDataOriginPackageRequired={validateDataOriginPackageRequired}
          setFileList={setFileList}
          fileList={fileList}
        />
      ),
      key: "1",
      visible: canViewOriginPackage,
    },
    {
      label: t("Origin_Package_Create.Create_Services.Title_Services"),
      children: canViewOriginPackageService && (
        <CreateOriginPackageServices
          t={t}
          type={isCreate ? CREATE : EDIT}
          detailData={dataOriginPackage}
          accessToken={accessToken}
        />
      ),
      key: "2",
      disabled: serviceTabDisabled,
      visible: canViewOriginPackageService,
    },
  ];
  const visibleItems = initialItems.filter((item) => item.visible);

  const selectOriginPackageRoue = [
    { value: "sea", label: t("Origin_Package_Create.Option_Route_Sea") },
    { value: "land", label: t("Origin_Package_Create.Option_Route_Land") },
  ];

  const canShowSaveButton =
    (isCreate && hasPermission(permissions.OriginPackage.ADD)) ||
    (isEdit && (hasPermission(permissions.OriginPackage.CHANGE) || hasPermission(permissions.OriginPackage.ADD)));

  const canShowRequiredFieldsHint =
    hasPermission(permissions.OriginPackage.ADD) || hasPermission(permissions.OriginPackage.CHANGE);

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row style={{ overflowX: "auto" }}>
          <Col span={24}>
            <Row justify={"space-between"} className="mb-2">
              <Col>
                <Title level={2}>
                  {!isEdit
                    ? t("Origin_Package_Create.Title_Origin_Package_Create")
                    : t("Origin_Package_Create.Title_Origin_Package_Edit")}
                </Title>
              </Col>
              {isEdit && (
                <Col>
                  <BtnHistory
                    titleRef={originPackageData?.reference}
                    object_id={originPackageData?.id}
                    content_type_id={[ContentType.OriginPackage, ContentType.OriginPackageService]}
                  />
                </Col>
              )}
            </Row>
          </Col>
          <Col span={22} style={{ minWidth: 640 }}>
            <Form
              form={formOriginPackage}
              labelAlign="left"
              labelCol={{ flex: "180px" }}
              disabled={isReadOnlyByPermission}
            >
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Shipping") + ":"}
                    name="shipping"
                    key="shipping"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <Input size="default" placeholder={"shipping"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Reference") + ":"}
                    name="reference"
                    key="reference"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <Input size="default" placeholder={"reference"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Box") + ":"}
                    name="box"
                    key="box"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input size="default" placeholder={"box"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Tracking") + ":"}
                    name="tracking"
                    key="tracking"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <Input size="default" placeholder={"tracking"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Custom_Number") + ":"}
                    name="custom_no"
                    key="custom_no"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input size="default" placeholder={"Custom number"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Route") + ":"}
                    name="route"
                    key="route"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      placeholder={"route"}
                      options={selectOriginPackageRoue}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Origin") + ":"}
                    name="origin"
                    key="origin"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      placeholder={"Please Select Route"}
                      options={listWareHouseOrigin}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Destination") + ":"}
                    name="destination"
                    key="destination"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      placeholder={"Please Select Route"}
                      options={listWareHouseDestination}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Time") + ":"}
                    name="origin_package_time"
                    style={{ marginBottom: "1rem" }}
                  >
                    <DatePicker
                      className="w-full"
                      showTime={DATETIME_PICKER_SHOW_TIME}
                      format={DATETIME_PICKER_FORMAT}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Transportation_Time") + ":"}
                    name="origin_transportation_time"
                    style={{ marginBottom: "1rem" }}
                  >
                    <DatePicker
                      className="w-full"
                      showTime={DATETIME_PICKER_SHOW_TIME}
                      format={DATETIME_PICKER_FORMAT}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Destination_Package_Time") + ":"}
                    name="destination_package_time"
                    style={{ marginBottom: "1rem" }}
                  >
                    <DatePicker
                      className="w-full"
                      showTime={DATETIME_PICKER_SHOW_TIME}
                      format={DATETIME_PICKER_FORMAT}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Destination_Delivery_Time") + ":"}
                    name="destination_delivery_time"
                    style={{ marginBottom: "1rem" }}
                  >
                    <DatePicker
                      className="w-full"
                      showTime={DATETIME_PICKER_SHOW_TIME}
                      format={DATETIME_PICKER_FORMAT}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Note") + ":"}
                    name="note"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input size="default" placeholder={"note"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Company") + ":"}
                    name="company"
                    key="company"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      allowClear
                      showSearch
                      loading={loadingCompany}
                      placeholder={"Please Select Company"}
                      options={listCompany}
                      filterOption={filterOptionCompany}
                      notFoundContent={loadingCompany ? <Spin size="small" /> : "No data"}
                      onSelect={(value) => {
                        setSelectedCompany(value);
                        const filteredSales = allSales.filter((sale) => sale.value.startsWith(`${value},`));
                        setListSale(filteredSales);
                        setListCustomer([]);
                        formOriginPackage.setFieldsValue({ sale: undefined, customer: undefined });
                      }}
                      onClear={() => {
                        setSelectedSale(null);
                        setSelectedCompany(null);
                        formOriginPackage.setFieldsValue({
                          sale: undefined,
                          customer: undefined,
                        });
                        setListSale(allSales);
                        setListCustomer(allCustomers);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Sale") + ":"}
                    name="sale"
                    key="sale"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      allowClear
                      showSearch
                      loading={loadingSale}
                      placeholder={"Please Select Sale"}
                      options={listSale}
                      filterOption={filterOptionSale}
                      notFoundContent={loadingSale ? <Spin size="small" /> : "No data"}
                      onSelect={(value) => {
                        const [companyId, saleId] = value.split(",");
                        setSelectedCompany(companyId);
                        setSelectedSale(saleId);
                        const filteredCustomers = allCustomers.filter((customer) =>
                          customer.value.startsWith(`${companyId},${saleId},`)
                        );
                        setListCustomer(filteredCustomers);
                        formOriginPackage.setFieldsValue({ company: companyId, customer: undefined });
                      }}
                      onClear={() => {
                        setSelectedSale(null);
                        formOriginPackage.setFieldsValue({
                          customer: undefined,
                        });
                        setListCustomer(allCustomers);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Origin_Package_Create.Input_Origin_Package_Customer") + ":"}
                    name="customer"
                    key="customer"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      allowClear
                      showSearch
                      loading={loadingCustomer}
                      placeholder={"Please Select Customer"}
                      options={listCustomer}
                      onSearch={handleSearchCustomer}
                      filterOption={filterOption}
                      notFoundContent={loadingCustomer ? <Spin size="small" /> : "No data"}
                      onSelect={(value) => {
                        const [companyId, saleId, customerId] = value.split(",");
                        setSelectedCompany(companyId);
                        setSelectedSale(saleId);
                        formOriginPackage.setFieldsValue({
                          company: companyId,
                          sale: `${companyId},${saleId}`,
                        });
                      }}
                      onClear={() => {
                        setSelectedCompany(null);
                        setSelectedSale(null);
                        formOriginPackage.setFieldsValue({
                          company: undefined,
                          sale: undefined,
                        });
                        setListCustomer(allCustomers);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              <Tabs type="card" activeKey={activeTabKey} items={visibleItems} onChange={handleTabsChange} />
            </Card>
          </Col>
        </Row>
        {activeTabKey === "1" && (
          <div style={{ marginTop: 20, textAlign: "right" }}>
            {canShowRequiredFieldsHint && (
              <div style={{ marginBottom: 8 }}>
                <Text type="danger">***{t("Origin_Package_Create.Hint_Required_Fields_Before_Save")}</Text>
              </div>
            )}
            <Space size={12} wrap>
              {isCreate && hasPermission(permissions.OriginPackage.ADD) && (
                <Button type="primary" disabled={saveButtonDisabled} onClick={onSaveAddAnother}>
                  {t("Button_Packages.BTN_Save_And_Add_Another", { ns: "packages" })}
                </Button>
              )}
              {canShowSaveButton ? (
                <Button type="primary" disabled={saveButtonDisabled} onClick={onSubmit}>
                  {t("BTN_Save", { ns: "buttons" })}
                </Button>
              ) : undefined}
              <Button type="default" onClick={() => navigation("/package/originpackage")}>
                {t("BTN_Cancel", { ns: "buttons" })}
              </Button>
            </Space>
          </div>
        )}
      </Spin>
    </>
  );
};
